module.exports = __webpack_public_path__ + "static/img/help_01desc_01.3bf506c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_01desc_01.jpg
// module id = 674
// module chunks = 140